export default "__VITE_ASSET__Bqb621xr__"